import { render, staticRenderFns } from "./ClockPeopleIcon.vue?vue&type=template&id=4fc89cea&"
import script from "./ClockPeopleIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockPeopleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports